<template>
  <div class="policeLato" style="background-color: #f5f6f6;">
    <router-view></router-view>
    <NewsletterAssurancePart></NewsletterAssurancePart>

    <div class="payement">
      <MyFreeDevisButton></MyFreeDevisButton>
      <div class="">
        <img width="50" height="30" alt="logo" src="../assets/img/logoPaiement/orange-money.png"/>
        <img width="60" height="30" alt="logo" src="../assets/img/logoPaiement/freemoney.png"/>
        <img class="pt-1" width="60" height="25" alt="logo" src="../assets/img/logoPaiement/visa.png"/>
        <img class="ml-1" width="60" height="30" alt="logo" src="../assets/img/logoPaiement/master-card.png"/>
        <img class="ml-2" width="30" height="30" alt="logo" src="../assets/img/logoPaiement/wave.png"/>
        <img class="ml-3" width="30" height="30" alt="logo-kpay" src="../assets/img/logoPaiement/kpay_logo.webp"/>
      </div>
    </div>
  </div>
</template>

<script>
import NewsletterAssurancePart from '../components/assurance_page_component/NewsletterAssurancePart.vue';
import MyFreeDevisButton from '../components/layouts/boutons/MyFreeDevisButton.vue';
import PushInDataLayer from '../services/TagManager';

export default {
  name: "DescriptionAssuranceVie",
  components: {
    NewsletterAssurancePart,
    MyFreeDevisButton
  },
  mounted() {
    let GtmVal ={
        branche:'vie',
        event:'view_assur_page'
    }
    PushInDataLayer(GtmVal)
  }
}
</script>

<style scoped>
.payement {
  display: flex;
  justify-content: space-between;
  padding: 45px 8%;
}
@media screen and (max-width: 700px) {
  .payement {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 15px;
    padding: 25px 0;
  }
}
</style>